const selectors = {
  popupComponent: 'popup-component',
  close: '[data-popup-close]',
  notificationForm: '[data-notification-form]',
  notificationHeading: '[data-product-notification-heading]',
};
const classes = {
  success: 'has-success',
  hidden: 'hidden',
};

if (!customElements.get('product-notification')) {
  customElements.define(
    'product-notification',
    class ProductNotification extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.companyId = 'NrdGm5';

        if (this.form) {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
      }

      onSubmitHandler(e) {
        e.preventDefault();

        const formData = new FormData(this.form);
        const email = formData.get('email');
        const variantId = formData.get('variant');
        const formMessages = this.querySelectorAll('.notify-message');

        formMessages.forEach((message) => {message.classList.add('hidden');});

        if (!this.validateEmail(email)) {
          this.showMessage('error-email');
          return false;
        }

        const config = {
          method: 'POST',
          headers: {accept: 'application/json', revision: '2024-02-15', 'content-type': 'application/json'},
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: `${email}`,
                    },
                  },
                },
                channels: ['EMAIL'],
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${variantId}`,
                  },
                },
              },
            },
          }),
        };

        this.sendRequest(config);
      }

      sendRequest(config) {
        const _this = this;

        fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.companyId}`, config)
          .then((response) => {
            response.status === 202 ? _this.showMessage('success') : _this.showMessage('error');
          })
          .catch((err) => {
            console.error(err);
            _this.showMessage('error');
          });
      }

      validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }

      showMessage(type) {
        const message = this.querySelector('.notify-message__' + type);
        if (!message) return;

        message.classList.remove('hidden');

        setTimeout(() => {
          const timeoutMessage = this.querySelector('.notify-message__' + type);
          if (timeoutMessage) {
            timeoutMessage.classList.add('hidden');
          }
        }, 6000);
      }
    }
  );
}
